/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsChannelPlatformResponseDto>>;
export function request(
  params: API.tms.logisticsChannelPlatform.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelPlatform/list`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
